package com.bikompanion.data.analytics

import com.bikompanion.domain.analytics.AnalyticsEvent

/*
 * Analytics and crash reporting as each target can do them: Firebase on Android, the GA4
 * Measurement Protocol through `/api/analytics` on web, and nothing on desktop, whose Firebase
 * targets are stubs.
 */

internal expect fun configurePlatformTelemetry(enabled: Boolean)

internal expect fun trackPlatformEvent(event: AnalyticsEvent)

internal const val PlatformParameter = "app_platform"

/**
 * Turns telemetry on or off for this process. Hosts call it once at startup, before the UI, and
 * pass false for local and debug builds.
 */
fun configureTelemetry(enabled: Boolean) {
    runCatching { configurePlatformTelemetry(enabled) }
}
